module.exports = __webpack_public_path__ + "static/img/lqbg.1cdb4b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lqbg.png
// module id = wtdh
// module chunks = 1